export default __webpack_public_path__ + "static/media/Cmder.81bd8505.png";